import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="w-full py-16 px-4 md:px-8 bg-cream" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-126">
          {/* Left: Image Placeholder */}
          <div className="w-full md:w-1/2 rounded-2xl overflow-hidden" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/cVekeEwowfSw3TXGgMYdoe/Magen_Darm_4f46689c-206a-426f-9344-0505df3c965a.webp" alt="Hunderunde Futtertopping Magen & Darm Verpackung" className="w-full h-auto object-contain" data-id="element-128" />
          </div>

          {/* Right: Text */}
          <div className="w-full md:w-1/2" data-id="element-129">
            <h2 className="font-handwritten text-4xl md:text-5xl text-forestGreen font-bold mb-6" data-id="element-130">
              Was ich bestellt habe
            </h2>
            <p className="font-serif text-lg text-gray-800 leading-relaxed mb-4" data-id="element-131">
              Ich hatte schon so viele Produkte ausprobiert – Shampoos, Diäten,
              sogar Cortison.
            </p>
            <p className="font-serif text-lg text-gray-800 leading-relaxed" data-id="element-132">
              Aber dieses Topping war anders: rein pflanzlich, speziell für den
              Magen-Darm-Trakt entwickelt, und ohne künstliche Zusätze.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}